@if (isOpen) {
<div class="rt5-backdrop" (click)="close()"></div>
<div class="rt5-modal" (click)="$event.stopPropagation()">

  <!-- Header -->
  <div class="rt5-header">
    <div class="rt5-header__left">
      <img [src]="headerIcon" alt="" class="rt5-header__icon"
        (error)="headerIcon='assets/performance/award.svg'" />
      <span class="rt5-header__title">{{ title }}</span>
    </div>
    <button class="rt5-header__close" (click)="close()">✕</button>
  </div>

  <!-- List -->
  <div class="rt5-list">
    @for (unit of units; track unit.rank) {
    <div class="rt5-row">
      <span class="rt5-rank">{{ unit.rank }}</span>
      <img *ngIf="unit.flag" [src]="unit.flag" [alt]="unit.country" class="rt5-flag"
        (error)="unit.flag=''" />
      <div class="rt5-info">
        <span class="rt5-unit">{{ unit.unitName }}</span>
        <span *ngIf="unit.country" class="rt5-country">{{ unit.country }}</span>
      </div>
    </div>
    }
    @if (!units.length) {
    <p class="rt5-empty">{{ "LEADERBOARD_OVERALL.NO_DATA_AVAILABLE" | translate }}</p>
    }
  </div>

</div>
}
